import { atom } from 'recoil'

export const pageState = atom({
  key: 'SourceEdit__pageState',
  default: {
    loaded: false,
    loading: false,
    loadingMsg: '',
    error: false,
    severity: 'danger',
    text: '',
    exportJson: false
  }
})
